/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.LOGIN_REQUEST]: state => {
    state.loginPending = true;
    state.loginFailed = false;
    state.loginSucceeded = false;
    state.loginErrors = null;
  },
  [types.LOGIN_SUCCESS]: (state, response) => {
    state.loginPending = false;
    state.loginSucceeded = true;
    localStorage.setItem('token', response.data.token);
  },
  [types.LOGIN_FAILURE]: (state, error) => {
    state.loginPending = false;
    state.loginSucceeded = false;
    state.loginFailed = true;
    state.loginErrors = error;
  },

  [types.LOGOUT_REQUEST]: state => {
    state.loginPending = false;
    state.loginSucceeded = false;
    localStorage.removeItem('token');
    window.location.assign('/login');
  },

  [types.PASSWORD_RESET_REQUEST]: state => {
    state.passwordResetPending = true;
    state.passwordResetFailed = false;
    state.passwordResetSucceeded = false;
  },
  [types.PASSWORD_RESET_SUCCESS]: state => {
    state.passwordResetPending = false;
    state.passwordResetFailed = false;
    state.passwordResetSucceeded = true;
  },
  [types.PASSWORD_RESET_FAILURE]: state => {
    state.passwordResetPending = false;
    state.passwordResetFailed = true;
    state.passwordResetSucceeded = false;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js